<div class="card">
    <div class="hmf-display-flex hmf-mb-xs hmf-justify-content-between">
        <span class="title">Verify your address </span><img (click)="close()" class="nav-icon" src="assets/image/Close.svg" alt="Close"/></div>
    <p class="message">The address provided cannot be verified. Please review.</p>

    <div class="addressesContainer hmf-display-flex hmf-flex-row">
        <div class="addressBlock suggestedAddressgutter hmf-p-xs">
            <p class="addressTitle">Suggested address</p>
            <span class="linebreak">{{names?.firstName}} {{names?.lastName}}</span>
            <span class="linebreak">{{suggestedAddress?.addressLines[0]}}</span>
            <span *ngIf="suggestedAddress?.addressLines[1]" class="linebreak">{{suggestedAddress?.addressLines[1]}}</span>
            <span>{{suggestedAddress?.city ? suggestedAddress?.city : ''}} {{', ' + suggestedAddress?.state ? suggestedAddress?.state: ''}} {{', ' + suggestedAddress?.zipCode ? suggestedAddress?.zipCode: ''}}</span>
            <button
                hmf-button
                variant="primary"
                id="useSuggestedAddress"
                class="hmf-mx-auto  hmf-w-100 hmf-mt-xs"
                (click)="buttonClicked(true)"
            >USE SUGGESTED ADDRESS</button>
        </div>

        <div class="addressBlock enteredAddressGutter hmf-p-xs">
            <p class="addressTitle">Entered address</p>
            <span class="linebreak">{{names?.firstName}} {{names?.lastName}}</span>
            <span class="linebreak">{{unverifiedAddress?.addressLines[0]}}</span>
            <span *ngIf="unverifiedAddress?.addressLines[1]" class="linebreak">{{unverifiedAddress?.addressLines[1]}}</span>
            <span>{{unverifiedAddress?.city ? unverifiedAddress?.city: ''}} {{', ' + unverifiedAddress?.state ? unverifiedAddress?.state : ''}} {{', ' +unverifiedAddress?.zipCode ? unverifiedAddress?.zipCode: ''}}</span>
            <button
                hmf-button
                variant="secondary"
                class="hmf-my-0 hmf-align-self-stretch hmf-w-100 hmf-mt-xs"
                data-testid="confirm-remove-item-modal-no-button"
                (click)="buttonClicked(false)"
            >EDIT ADDRESS</button>
        </div>
    </div>
</div>
